export enum SharePermission {
  FullAccess = 'IMPERSONATE',
  ReadOnly = 'IMPERSONATE_READ_ONLY',
  ReadAndUpload = 'IMPERSONATE_READ_UPLOAD_ONLY'
}
